module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/bg-f91a9359d0e21bc77e6e7b308f743a02.png";